import {Dispatch, SetStateAction} from "react";
import {useModal} from "../../../../../hooks";

interface PropsType {
    tab: string
    setTab: Dispatch<SetStateAction<string>>
    isModify: boolean
    menuTitleText: string
}

export default function TabNav({tab, setTab, isModify, menuTitleText}: PropsType) {
    const {handleModal} = useModal();

    const clickTab = (str: string) => {
        if (isModify) {
            handleModal({
                isOpen: true,
                contents: "편집 중에는 탭을 변경할 수 없습니다.",
                type: "alert",
            });
        } else {
            setTab(str)
        }
    }

    return <div className="mybtns_group">
        <div className="btn-group" role="group" aria-label="">
            <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-1")}>{menuTitleText}정보
            </button>
            <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"}
                    onClick={() => clickTab("tab-2")}>품목정보
            </button>
        </div>
        <div className="mybtns_group_toolbar"></div>
    </div>
}